<div class="cross-button cross-button--{{size}}">
    <div class="cross-button-icon cross-button-icon--{{size}}"></div>
</div>
